// extracted by mini-css-extract-plugin
export default {"add-shadow":"Terms_add-shadow__CrjhM","toolTip":"Terms_toolTip__Bd1yG","terms":"Terms_terms__iWboL","table":"Terms_table__D+MqB"};